import { create } from "zustand";
import type { ChartPanelId } from "@/vybe-trader-client/chart/stores/chartPanelTypes";
import type { ChartDeskSlot } from "./types";

interface ChartDeskRestoreState {
  /**
   * Panels whose stored symbol has not been resolved yet — the symbol universe
   * arrives asynchronously after connect, so the chart is briefly empty for a
   * reason the trader can be told about.
   */
  pending: Partial<Record<ChartPanelId, ChartDeskSlot>>;
  markPending: (slots: Partial<Record<ChartPanelId, ChartDeskSlot>>) => void;
  clearPending: (panelId: ChartPanelId) => void;
}

export const useChartDeskRestoreStore = create<ChartDeskRestoreState>((set) => ({
  pending: {},
  markPending: (slots) => set({ pending: slots }),
  clearPending: (panelId) =>
    set((state) => {
      if (!state.pending[panelId]) return state;
      const next = { ...state.pending };
      delete next[panelId];
      return { pending: next };
    }),
}));
